export default {
  name: "TrainingCategory",
  computed: {
    trainingCategories() {
      return this.$store.getters["trainingCategory/getTrainingCategories"] || [];
    },
    totalItems() {
      return this.$store.getters["trainingCategory/getTotalItems"] || 0;
    },
    isLoading() {
      return this.$store.getters["trainingCategory/getLoading"];
    },
    roleCompetencyOptions() {
      return this.$store.getters["roleCompetency/getRoleCompetencies"] || [];
    }
  },
  data() {
    return {
      // Permissions
      listTabMenu: {
        privilages: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      },

      // Request body for API
      body: {
        page: 1,
        limit: 10,
        search: "",
        // role_competency_id: "",
        // sort_field: "",
        // sort_direction: ""
      },

      // Filters
      filters: {
        search: "",
        role_competency_id: ""
      },

      // Form data
      bodyAdd: {
        abbreviation: "",
        title: "",
        role_competency_id: null
      },
      bodyUpdate: {
        id: null,
        abbreviation: "",
        title: "",
        role_competency_id: null
      },

      // Modal and form state
      showModal: false,
      isAdd: true,
      modalTitle: "Add Training Category",
      formErrors: {},
      isSubmitting: false,
      searchTimeout: null,

      // Options
      searchTimeout: null,

      // Table columns
      columns: [
        // {
        //   label: 'ID',
        //   field: 'id',
        //   width: '80px',
        //   type: 'number',
        //   sortable: true
        // },
        {
          label: 'Abbreviation',
          field: 'abbreviation',
          sortable: true
        },
        {
          label: 'Title',
          field: 'title',
          sortable: true
        },
        {
          label: 'Role Competency',
          field: 'role_competency_name',
          sortable: true
        },
        {
          label: "Actions",
          field: "actions",
          sortable: false,
          thClass: "text-center",
          tdClass: "text-center"
        }
      ]
    };
  },

  mounted() {
    // Load data
    this.getTrainingCategories();
    this.getRoleCompetencies();
    
    // Set menu permissions
    this.setMenuPermissions();
  },

  methods: {
    // Set menu permissions
    setMenuPermissions() {
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || '[]');
      const currentPath = window.location.pathname;
      const menu = listMenu.find((menu) =>
        menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
      );
      this.listTabMenu = menu ? menu.children.find((item) => item.link === currentPath) || menu : {};
    },

    // API calls
    getTrainingCategories() {
      this.$store.dispatch("trainingCategory/getTrainingCategories", this.body);
    },

    getRoleCompetencies() {
      this.$store.dispatch("roleCompetency/getRoleCompetencies");
    },

    // Search with debounce
    onSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.body.search = this.filters.search;
        this.body.page = 1;
        this.getTrainingCategories();
      }, 500);
    },

    // Filter change
    onFilterChange() {
      this.body.role_competency_id = this.filters.role_competency_id;
      this.body.page = 1;
      this.getTrainingCategories();
    },

    // Clear filters
    clearFilter() {
      this.filters = {
        search: "",
        role_competency_id: ""
      };
      this.body = {
        page: 1,
        limit: 10,
        search: "",
        // role_competency_id: "",
        // sort_field: "",
        // sort_direction: ""
      };
      this.getTrainingCategories();
    },

    // Pagination
    onPageChange(params) {
      this.body.page = params.currentPage;
      this.getTrainingCategories();
    },

    onPerPageChange(params) {
      this.body.limit = params.currentPerPage;
      this.body.page = 1;
      this.getTrainingCategories();
    },

    // Sorting
    onSortChange(params) {
      if (params && params.length > 0) {
        this.body.sort_field = params[0].field;
        this.body.sort_direction = params[0].type;
      } else {
        this.body.sort_field = '';
        this.body.sort_direction = '';
      }
      this.getTrainingCategories();
    },

    // Modal actions
    addTrainingCategory() {
      this.isAdd = true;
      this.modalTitle = "Add Training Category";
      this.resetForm();
      this.showModal = true;
    },

    editTrainingCategory(data) {
      this.isAdd = false;
      this.modalTitle = "Edit Training Category";
      
      this.bodyUpdate = {
        id: data.id,
        abbreviation: data.abbreviation || "",
        title: data.title || "",
        role_competency_id: data.role_competency.id || null
      };
      
      this.formErrors = {};
      this.showModal = true;
    },

    deleteTrainingCategory(data) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: `Hapus kategori pelatihan "${data.title}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("trainingCategory/deleteTrainingCategory", data.id)
            .then(() => {
              this.$swal("Terhapus", "Kategori pelatihan telah dihapus", "success");
              this.getTrainingCategories();
            })
            .catch((error) => {
              console.error('Error deleting training category:', error);
              this.$swal("Error", "Kategori pelatihan belum berhasil dihapus", "error");
            });
        }
      });
    },

    // Form handling
    resetForm() {
      this.bodyAdd = {
        abbreviation: "",
        title: "",
        role_competency_id: null
      };
      this.bodyUpdate = {
        id: null,
        abbreviation: "",
        title: "",
        role_competency_id: null
      };
      this.formErrors = {};
      this.isSubmitting = false;
    },

    // Form validation
    validateForm() {
      this.formErrors = {};
      const formData = this.isAdd ? this.bodyAdd : this.bodyUpdate;

      if (!formData.abbreviation || formData.abbreviation.trim() === '') {
        this.formErrors.abbreviation = "Abbreviation is required";
      } else if (formData.abbreviation.length > 10) {
        this.formErrors.abbreviation = "Abbreviation must not exceed 10 characters";
      }

      if (!formData.title || formData.title.trim() === '') {
        this.formErrors.title = "Title is required";
      }

      if (!formData.role_competency_id) {
        this.formErrors.role_competency_id = "Role Competency is required";
      }

      return Object.keys(this.formErrors).length === 0;
    },

    // Save training category
    async saveTrainingCategory() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;

      try {
        const formData = this.isAdd ? this.bodyAdd : this.bodyUpdate;
        
        if (this.isAdd) {
          const response = await this.$store.dispatch("trainingCategory/createTrainingCategory", formData);
          if (response && (response.success || response.data)) {
            this.$swal({
              title: "Success",
              text: "Kategori pelatihan berhasil dibuat",
              icon: "success",
              confirmButtonText: "OK"
            }).then(() => {
              this.showModal = false;
              this.getTrainingCategories();
            });
          }
        } else {
          const response = await this.$store.dispatch("trainingCategory/updateTrainingCategory", {
            id: formData.id,
            data: formData
          });
          if (response && (response.success || response.data)) {
            this.$swal({
              title: "Success",
              text: "Kategori pelatihan berhasil diperbarui",
              icon: "success",
              confirmButtonText: "OK"
            }).then(() => {
              this.showModal = false;
              this.getTrainingCategories();
            });
          }
        }
      } catch (error) {
        console.error('Error saving training category:', error);
        let errorMessage = "Error while saving training category";
        
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.errors) {
            // Handle validation errors
            const validationErrors = Object.values(errorData.errors).flat();
            errorMessage = validationErrors.join(', ');
          }
        }
        
        this.$swal("Error", errorMessage, "error");
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
